module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "c-card--claim-forms__body"
  }, [_c('transition', {
    attrs: {
      "name": "fade-and-slide"
    }
  }, [(_vm.submittedForm !== null) ? _c('div', {
    ref: "toast",
    staticClass: "c-toast t-toast-success"
  }, [_c('p', {
    staticClass: "c-toast__text"
  }, [_vm._v("\n          " + _vm._s((_vm.forms[_vm.submittedForm] && _vm.forms[_vm.submittedForm].submitMessage) ||
    _vm.$t('web.form_list.success_message')) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-card--claim-forms__form-list qa-form-list"
  }, _vm._l((_vm.forms), function(form, formIndex) {
    return _c('div', {
      staticClass: "c-card--claim-forms__form-list__button qa-select-form-button",
      on: {
        "click": function($event) {
          return _vm.openForm(formIndex)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(form.name))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-arrow-right t-headline"
    })])
  }), 0)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-395032fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/forms/FormList.vue
// module id = 525
// module chunks = 1